import {cdnImage} from '@/util/cdnImage';
import {MUIContainer} from '@/components/MUI-Components';
import {LARAVEL_META_DATA} from '@/util/metaData/web';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
import PageHead from '@/components/PageHead';

// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {
        aithenicCheckPointData,
        laravelAithenticButtonData,
        laravelBannerBottom,
        laravelBannerPoint,
        laravelBenefitData,
        laravelCentricData,
        laravelChooseBody,
        laravelChooseContent,
        laravelCimetButtonData,
        laravelClientCarousel,
        laravelCoreFeatureData,
        laravelDecodingData,
        laravelDevelopmentService,
        laravelEnhancementService,
        laravelFAQData,
        laravelMobileProcess,
        laravelTechnologyData
    } = await import('@/util/contents/laravel-development');

    const {customSoftwareCimet} = await import('@/util/contents/custom-software-development-company');

    const {flutterP2BButtonData, flutterP2BCheckPoint} = await import('@/util/contents/flutter-data');

    return {
        props: {
            aithenicCheckPointData,
            laravelAithenticButtonData,
            laravelBannerBottom,
            laravelBannerPoint,
            laravelBenefitData,
            laravelCentricData,
            laravelChooseBody,
            laravelChooseContent,
            laravelCimetButtonData,
            laravelClientCarousel,
            laravelCoreFeatureData,
            laravelDecodingData,
            laravelDevelopmentService,
            laravelEnhancementService,
            laravelFAQData,
            laravelMobileProcess,
            laravelTechnologyData,
            customSoftwareCimet,
            flutterP2BButtonData,
            flutterP2BCheckPoint
        }
    };
};

const Banner = dynamic(() => import('@/components/Ui-components/Banner'));
const HelperSection = dynamic(() => import('@/components/Ui-components/helper-section'));
const Questions = dynamic(() => import('@/components/Ui-components/questions'));
const Testimonials = dynamic(() => import('@/components/Ui-components/Testimonials'));
const LatestInsights = dynamic(() => import('@/components/Ui-components/latest-insights'));
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));
const Decoding = dynamic(() => import('@/components/Ui-components/Decoding'));
const auditImg = cdnImage('laravel/Laravel-Software-Development.webp');
const LatestCTA = dynamic(() => import('@/components/Ui-components/LatestCta'));
const Platforms = dynamic(() => import('@/components/Ui-components/platforms'));
const OurServices = dynamic(() => import('@/components/Ui-components/our-services'));
const DynamicScreens = dynamic(() => import('@/components/Ui-components/Dynamic-screens'));
const cimet = cdnImage('hire-remote-developer/cimet.webp');
const aithenic = cdnImage('hire-remote-developer/Aithentic.webp');
const p2b = cdnImage('flutter-app/P2b.webp');
const CardTechnology = dynamic(() => import('@/components/Ui-components/card-technology'));
const MobileProcess = dynamic(() => import('@/components/Ui-components/MobileProcess'));
const development = cdnImage('laravel/Laravel-Development-Process.svg');
import {meetingLink} from '@/constants';
const OurMakeChoice = dynamic(() => import('@/components/Ui-components/OurMakeChoice'));
const LetsDiscuss = dynamic(() => import('@/components/Ui-components/Lets-discuss'));
import AggregateScript from '@/components/Common/Aggregate-script';
import {CDN_URL, SITE_URL} from '@/constants/urls';

const LaravelDevelopment = (props: any) => {
    const {
        openForm,
        aithenicCheckPointData,
        laravelAithenticButtonData,
        laravelBannerBottom,
        laravelBannerPoint,
        laravelBenefitData,
        laravelCentricData,
        laravelChooseBody,
        laravelChooseContent,
        laravelCimetButtonData,
        laravelClientCarousel,
        laravelCoreFeatureData,
        laravelDecodingData,
        laravelDevelopmentService,
        laravelEnhancementService,
        laravelFAQData,
        laravelMobileProcess,
        laravelTechnologyData,
        customSoftwareCimet,
        flutterP2BButtonData,
        flutterP2BCheckPoint
    } = props;
    const aithenticPoint = [
        'An advanced IT asset management solution, designed and developed by our AI developers and software development team, streamlines asset tracking, enhances data accuracy, and optimizes usage across all assets. The project transitioned from a successful pilot phase to full deployment, ensuring enhanced business efficiency with scalable solutions tailored for comprehensive enterprise management.'
    ];
    return (
        <Box className="laravel-main-parent">
            <PageHead meta={LARAVEL_META_DATA} url="/laravel-development" />
            <Banner
                priority={true}
                handleClickOpen={meetingLink}
                heading="Laravel Development Company"
                subheading="We deliver secure, scalable, and cleanly coded Laravel solutions tailored to your goals. Our expert team builds performance-first web applications using the MVC pattern to ensure speed, stability, and long-term business impact."
                button="Explore with us today"
                image={cdnImage('laravel/Laravel-Development-Company.webp')}
                bannerClass="manual-banner"
                // bannerBackground="new-home-banner-background "
                alt="Laravel Development Company"
                DataPoints={laravelBannerPoint}
                meetingLink={true}
            />
            <Box className="sub-banner-wrapper">
                <MUIContainer>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between" className="white-label-bottom-container">
                        <Grid item md={2} lg={1.7} sm="auto" xs={12}>
                            <Typography className="banner-bottom-heading">Our Strategic Alliances</Typography>
                        </Grid>
                        {laravelBannerBottom?.map((data: any, index: number) => (
                            <Grid item sm="auto" xs={6} className="sub-banner-images" key={index + 1}>
                                <Box className="images-banner-bottom">
                                    <DisplayImage src={data.src} alt={data.alt} />
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="bottom-margin top-space decording-main-wrapper mobile-top-padding mobile-bottom-margin">
                <MUIContainer>
                    <Decoding
                        imageSrc={auditImg}
                        alt="Laravel Software Development Company: Scalable Web Solutions That Drive Business Results"
                        heading="Laravel Software Development Company: Scalable Web Solutions That Drive Business Results"
                        subHeading={laravelDecodingData}
                        imgSx={{width: 600, height: 'auto'}}
                        isSocialMediaBtn={true}
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions">
                            <Typography className="spectrum-heading color-black our-service-main-heading text-align-left" component="h2">
                                Laravel Development Services for Building Secure, Scalable Business Applications
                            </Typography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line divider-line-left" />
                            </Box>
                            <Box className="sub-heading-box" pb={4}>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    Our Laravel development services are designed to help businesses build scalable, high-performance web
                                    applications that align with their long-term goals. From secure backend systems to feature-rich
                                    enterprise platforms, we deliver robust solutions using clean code and modern architecture. Trust our
                                    experts to streamline development, enhance reliability, and support your digital transformation at every
                                    step.
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <HelperSection data={laravelDevelopmentService} className="home-helper-card" />
                        </Grid>
                    </MUIContainer>
                </Box>
            </Grid>
            <Box className="top-space mobile-top-padding">
                <LatestCTA
                    heading="Not Sure How to Fix Performance Bottlenecks in Your Current Business Web Application Architecture?"
                    buttonText="Get Free Consultation"
                    openForm={openForm}
                    className="blue-background-cta "
                />
            </Box>
            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <MUIContainer>
                    <Platforms
                        data={laravelEnhancementService}
                        heading="Laravel Customization and Enhancement Services to Future-Proof Your Web Application"
                        subheading="With deep expertise in Laravel and PHP frameworks, we help businesses enhance, scale, and fine-tune their web applications to meet evolving user demands, business goals, and industry standards. From refining legacy systems to adding new functionalities, our team ensures your application stays future-ready, efficient, and aligned with modern development practices."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space mobile-top-padding">
                    <Grid container spacing={2} className="our-service-defi-wrapper">
                        <OurServices
                            ourServices={laravelCentricData}
                            className="service-shadow-border-box enterprise-key-card"
                            containerClass="card-heading-spacing"
                            heading="Driving Business Efficiency Through Laravel-Centric Enhancements and Scalable Web Solutions"
                            subheading="We help businesses modernize and future-proof their digital infrastructure using Laravel’s flexible architecture. Our tailored strategies improve performance, simplify integrations, and strengthen security—enabling your web applications to scale confidently while meeting evolving operational needs and delivering a seamless user experience across every touchpoint."
                        />
                    </Grid>
                </Box>
            </Grid>
            <Box className="top-space mobile-top-padding">
                <LatestCTA
                    heading="Facing Challenges With Scalability and Security in Your Existing Custom Web Platform?"
                    buttonText="Talk To Our Experts"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="dynmaic-white-label-wrapper bottom-margin mobile-bottom-margin top-space mobile-top-padding ">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            Our Laravel Development Portfolio
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                    </Box>
                    <DynamicScreens
                        imageSrc={cimet}
                        subHeading="Cimet"
                        heading="Simplifying Decision-making Process Through Effortless Comparison"
                        subPoints={[
                            '<a target="_blank" href="/case-study/cimet">Cimet</a>, a leading Australian insurance and utility comparison platform, aimed to offer users a faster and simpler way to compare policies and utility plans. Debut Infotech implemented a scalable tech solution that streamlined comparison processes while enhancing overall platform performance.'
                        ]}
                        reverseOrder={true}
                        alt="Cimet"
                        checkItems={customSoftwareCimet}
                        buttonData={laravelCimetButtonData}
                        buttonClass="nft-button"
                        buttonLabel="View Case Study"
                        openForm={'/case-study/cimet'}
                        caseStudy={true}
                    />
                    <DynamicScreens
                        imageSrc={aithenic}
                        subHeading="Aithentic"
                        heading="An IT Asset Management System Forecasting Real-time Tech Spend"
                        subPoints={aithenticPoint}
                        reverseOrder={false}
                        alt="Aithentic"
                        checkItems={aithenicCheckPointData}
                        buttonData={laravelAithenticButtonData}
                        openForm={'/case-study/aithentic'}
                        buttonLabel="View Case Study"
                        buttonClass="helper-card-button"
                        caseStudy={true}
                    />
                    <DynamicScreens
                        imageSrc={p2b}
                        subHeading="P2B"
                        heading="An Innovative Solution Simplifying Procurement for the Mining Sector"
                        subPoints={[
                            'Debut Infotech partnered with P2B to build a robust <a target="_blank" href="/saas-development-company">SaaS</a>-based procurement management platform tailored for the mining industry. Designed with a mobile-first approach, P2B helps enterprises overcome inefficiencies tied to traditional procurement systems. From automating approval workflows to enhancing order traceability, the solution brings speed, transparency, and simplicity to a paper-heavy industry.'
                        ]}
                        reverseOrder={true}
                        alt="P2B"
                        checkItems={flutterP2BCheckPoint}
                        buttonData={flutterP2BButtonData}
                        openForm={'/case-study/p2b'}
                        buttonLabel="View Case Study"
                        buttonClass="nft-button"
                        imageClass="dynamic-exchange-image"
                        caseStudy={true}
                    />
                </MUIContainer>
            </Grid>
            <Grid item xs={12} className="bottom-spacing generative-tech-wrapper mobile-bottom-padding">
                <CardTechnology
                    heading="Laravel Development Tech Stack Our Team Uses to Build Scalable Web Solutions"
                    subheading="We utilize a modern, secure, and scalable Laravel development tech stack to deliver high-performing web applications tailored to your business goals. From backend frameworks to CI/CD pipelines, our tools ensure faster deployment, improved code quality, and long-term maintainability. Businesses that hire dedicated Laravel developers from Debut Infotech benefit from streamlined workflows and future-ready solutions."
                    data={laravelTechnologyData}
                />
            </Grid>
            <Box className="bottom-spacing mobile-bottom-padding">
                <LatestCTA
                    heading="Looking to Migrate From Legacy Systems to a More Scalable Laravel-Based Digital Infrastructure?"
                    buttonText="Share Your Vision"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Grid item xs={12} className="helper-section">
                <Box className="helper_section_parent bottom-spacing top-space mobile-top-padding mobile-bottom-padding">
                    <MUIContainer>
                        <Box className="spectrum-header-wrapper solutions">
                            <Typography className="spectrum-heading color-black our-service-main-heading text-align-left" component="h2">
                                From Static Systems to Scalable Solutions: Key Benefits of Laravel Development Services
                            </Typography>
                            <Box className="divder-wrapper">
                                <hr className="divider-line divider-line-left" />
                            </Box>
                            <Box className="sub-heading-box" pb={4}>
                                <Typography className="spectrum-sub-heading color-black spacing">
                                    As a trusted Laravel development agency,{' '}
                                    <a target="_blank" href="/">
                                        Debut Infotech
                                    </a>{' '}
                                    empowers businesses with scalable, secure, and tailored web applications. Whether you&apos;re
                                    modernizing internal systems or building client-facing platforms, our Laravel development solutions help
                                    drive efficiency, innovation, and digital agility.
                                </Typography>
                            </Box>
                        </Box>
                        <Grid container spacing={2}>
                            <HelperSection data={laravelBenefitData} className="home-helper-card" />
                        </Grid>
                    </MUIContainer>
                </Box>
            </Grid>
            <Grid item xs={12} className="blockchain-revolution-service bottom-spacing  mobile-bottom-padding top-space mobile-top-padding">
                <MUIContainer>
                    <Platforms
                        data={laravelCoreFeatureData}
                        heading="Core Features That Make Our Laravel Solutions Scalable, Secure, and Business-Focused"
                        subheading="As a leading Laravel <a target='_blank' href='/web-development'>web development company</a>, we craft web applications that do more than just function—they scale with your business, adapt to evolving demands, and deliver tangible results. From architecture to deployment, every feature we integrate is built to accelerate performance, security, and user engagement."
                        containerClass="blockchain-card-container"
                        className="platform-key-industry-service no-border"
                    />
                </MUIContainer>
            </Grid>
            <Box>
                <LatestCTA
                    heading="Need a Modular Web Platform That Can Evolve With Your Growing Operational Demands? We Can Help."
                    buttonText="Discuss Your Idea"
                    openForm={openForm}
                    className="blue-background-cta"
                />
            </Box>
            <Box className="bottom-spacing process-mobile-bottom-padding top-space mobile-top-padding">
                <MUIContainer>
                    <Box className="spectrum-header-wrapper solutions">
                        <Typography className="spectrum-heading color-black text-align-left" component="h2">
                            Our Laravel Development Process: From Planning to Scalable Digital Execution{' '}
                        </Typography>
                        <Box className="divder-wrapper">
                            <hr className="divider-line divider-line-left" />
                        </Box>
                        <Box className="sub-heading-box" pb={4}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left" component="p">
                                At Debut Infotech, we don’t just code—we architect Laravel-based digital experiences that are tailored for
                                business impact. Our process blends strategic planning, clean architecture, and scalable code to deliver
                                reliable solutions through every project milestone.
                            </Typography>
                        </Box>
                    </Box>
                    <Box textAlign="center">
                        <DisplayImage
                            src={development}
                            alt="Scalable Enterprise Solutions"
                            className="approach-main-img approach-web-img"
                        />
                    </Box>
                    <Box className="approach-main-img approach-mobile-img">
                        <MobileProcess mobileProcess={laravelMobileProcess} />
                    </Box>
                </MUIContainer>
            </Box>
            <OurMakeChoice
                heading="Why Choose Debut Infotech"
                subheading="as Your Laravel Development Company?"
                body={laravelChooseBody}
                contentData={laravelChooseContent}
            />

            <Grid item xs={12} className="bottom-spacing">
                <LetsDiscuss
                    heading="Ready to Build Scalable Web Solutions That Drive Business Efficiency?"
                    subheading="Streamline operations, improve performance, and accelerate growth with custom Laravel applications tailored to your specific business objectives."
                    btnLabel="Contact Our Experts Now"
                    className="white-label-sprill"
                    openForm={() => {
                        globalThis.open('/contact-us', '_blank');
                    }}
                />
            </Grid>

            <Grid item xs={12} className="question-parent top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={laravelFAQData} subpart={true} />
                </MUIContainer>
            </Grid>

            <Grid item xs={12}>
                <Box className="top-space mobile-top-padding bg-blue-background">
                    <Testimonials heading="Our Clients Describe Us Best" clientData={laravelClientCarousel} />
                </Box>
            </Grid>

            <Grid item xs={12} className="latest-insights top-space mobile-top-padding">
                <LatestInsights id="20" />
            </Grid>

            <script
                type="application/ld+json"
                id="laravel-development"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: [
                            {
                                '@type': 'Question',
                                name: 'What is the average cost of Laravel web development?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Laravel development costs vary based on project complexity, feature set, and engagement model. Simple applications may start around $5,000, while enterprise solutions can exceed $50,000. Costs also depend on whether you opt for fixed-price or time-and-material contracts. Laravel web development services offer scalable pricing options to align with your budget and technical goals.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How long does it take to build a Laravel application?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `The time required to build a Laravel application depends on project complexity, features, team size, and integration requirements. A Laravel web development company typically follows an agile process with defined sprints and review cycles, ensuring that milestones are met with consistency. Here’s a general breakdown of estimated timelines based on project scale:
Small-scale projects: 3–5 weeks
Mid-sized platforms: 6–10 weeks
Enterprise-grade systems: 12–20+ weeks`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Which company offers reliable Laravel development for businesses?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'A reliable Laravel partner is one that demonstrates consistent delivery, offers post-launch support, and understands business logic beyond code. Look for companies with verified portfolios, strong client retention, and real-world success stories. Debut Infotech, for instance, is considered among the best Laravel development companies for its strategic approach and B2B project execution.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How do I hire Laravel developers for my project?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Hiring the right team starts with understanding your goals, internal capacity, and the type of collaboration you need. Businesses that hire remote developers gain more flexibility and better control over deliverables, especially for ongoing development. Once goals are set, follow these steps:
Evaluate agencies with strong Laravel portfolios
Look for technical screening and transparency in hiring
Ensure timezone compatibility and fluent communication`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Can I outsource my Laravel project to an agency?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Yes, outsourcing Laravel projects is a common and efficient option for businesses lacking in-house capabilities. A trusted Laravel web development company will manage everything—from architecture to deployment—while aligning with your internal goals. Outsourcing helps you reduce overheads, access specialized talent, and accelerate time-to-market without compromising quality.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'Is Laravel suitable for long-term business application development?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: 'Laravel is highly suitable for long-term projects thanks to its modular structure, maintainable codebase, and active community. It supports evolving features, scale, and integrations over time. Opting for custom Laravel development ensures your application is tailored to your growth roadmap and can adapt to new technologies and user expectations without major rework.'
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What should a Laravel development contract include for businesses?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `To avoid future disputes and scope misalignment, your Laravel development contract must be clear, comprehensive, and aligned with your business needs. Reputable Laravel web development companies ensure these contracts protect both parties while detailing all technical and commercial terms. A good contract should include:
Project scope and defined deliverables
Development methodology and timeline
Payment structure and key milestones
Support, IP ownership, and confidentiality clauses`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How do Laravel agencies handle project deadlines and delivery?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Experienced Laravel development companies rely on structured methodologies like Agile or Scrum to manage timelines and ensure transparency throughout the project. These firms keep all stakeholders aligned through collaborative tools and milestone tracking. Their process typically includes:
Sprint planning and regular backlog grooming
Bi-weekly demos or client check-ins
Tools like Jira, Trello, or GitLab for visibility
Dedicated project managers and real-time reporting`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'What is the engagement model for Laravel development services?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Laravel agencies offer flexible engagement models based on business size, project scope, and development pace. These models help companies adapt to changing requirements, especially when they hire dedicated Laravel developers for extended collaboration. Common engagement models include:
Fixed-price – For short-term or clearly defined projects
Time & material – Ideal for evolving or agile builds
Dedicated team – Best for long-term or high-priority systems`
                                }
                            },
                            {
                                '@type': 'Question',
                                name: 'How do Laravel companies ensure transparency during the project?',
                                acceptedAnswer: {
                                    '@type': 'Answer',
                                    text: `Transparency is a core differentiator when working with a Laravel web development company. Agencies maintain openness through structured communication, shared dashboards, and regular reporting. The goal is to ensure complete visibility at every phase of development. Their approach typically includes:
Weekly or bi-weekly reporting
Access to Git repositories and task boards
Defined KPIs and review checkpoints
Dedicated account managers and client channels`
                                }
                            }
                        ]
                    })
                }}
            />
            <AggregateScript
                name="Laravel Development"
                image={`${CDN_URL}?url=%2Fimages%2Flaravel%2FLaravel-Development-Company.webp&w=750&q=75`}
                description="Unlock scalable, secure, and high-performing web solutions with our Laravel Development Services. We build custom applications using Laravel’s robust features for seamless performance and rapid deployment tailored to your business needs."
                offers={{
                    '@type': 'AggregateOffer',
                    url: `${SITE_URL}/laravel-development`,
                    priceCurrency: 'USD',
                    lowPrice: '50000',
                    highPrice: '100000',
                    offerCount: '10'
                }}
                aggregateRating={{
                    '@type': 'AggregateRating',
                    ratingValue: '4.9',
                    bestRating: '5',
                    worstRating: '2',
                    ratingCount: '399'
                }}
            />
        </Box>
    );
};
export default LaravelDevelopment;
LaravelDevelopment.Layout = 'Main';
